import { Routes } from '@angular/router';
import { CheckStatusComponent } from './check-status/check-status.component';
import { VakersShellFeatureMainNavComponent } from './main-nav/main-nav.component';
import { userAuthGuard } from './user-auth.guard';

export const vakersMainRoutes: Routes = [
  {
    path: '',
    loadComponent: () => VakersShellFeatureMainNavComponent,
    loadChildren: () => [
      {
        path: '',
        loadChildren: () =>
          import('@vaki/vakers/landings/feature/shell').then(
            (feat) => feat.landingRoutes
          )
      },
      {
        path: 'liveness_check',
        loadComponent: () => CheckStatusComponent
      },
      {
        path: 'readiness_check',
        loadComponent: () => CheckStatusComponent
      },
      {
        path: 'crear',
        data: { title: 'Crear Vaki', titleEn: 'Create Vaki' },
        loadChildren: () =>
          import('@vaki/vakers/vakis/feature/create').then(
            (module) => module.createMainRoutes
          )
      },
      {
        path: 'explorar',
        loadComponent: () =>
          import('@vaki/vakers/vakis/feature/explore').then(
            (feat) => feat.VakersVakisFeatureExploreComponent
          ),
        data: { hideFooter: true }
      },
      {
        path: 'checkout',
        data: { name: 'Checkout', color: 'primary' },
        loadChildren: () =>
          import('@vaki/vakers/checkout/feature/shell').then(
            (feat) => feat.checkoutMainRoutes
          )
      },
      {
        path: 'vaki',
        loadChildren: () =>
          import('@vaki/vakers/vakis/feature/view').then(
            (feat) => feat.crudRoutes
          )
      },
      {
        path: 'dashboard',
        data: { name: 'Dashboard' },
        canActivate: [userAuthGuard],
        loadChildren: () =>
          import('@vaki/vakers/dashboard/feature/shell').then(
            (feat) => feat.dashboardRoutes
          )
      },
      {
        path: 'blog',
        loadChildren: () =>
          import('@vaki/vakers/blog/feature/shell').then(
            (feat) => feat.vakersBlogFeatureShellRoutes
          )
      },
      {
        path: ':url',
        redirectTo: 'vaki/:url'
      }
    ]
  },
  {
    path: 'iframe/:vakiKey',
    loadChildren: () =>
      import('@vaki/vakers/vakis/feature/iframe').then((ui) => ui.iframeRoutes)
  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full'
  }
];
